import type { ComponentPropsWithoutRef, ReactNode } from 'react'
import { cx } from '@/lib/cx'

// S-3: outcome-differentiated card borders (applicant/status.tsx's decision
// reveal) — a border-color-only variant, not a full redesign.
export type CardBorderVariant = 'accepted' | 'waitlisted' | 'rejected'

type CardProps = ComponentPropsWithoutRef<'section'> & {
  title?: ReactNode
  borderVariant?: CardBorderVariant
}

export function Card({ title, borderVariant, className, children, ...props }: CardProps) {
  return (
    <section
      className={cx('card', borderVariant != null && `card--border-${borderVariant}`, className)}
      {...props}
    >
      <div className="card__body">
        {title != null && <h3 className="card__title mb-3">{title}</h3>}
        {children}
      </div>
    </section>
  )
}
